/**
 * 九宫格 7 块版（V1.1 §6.5）共享配置：
 *
 *   素质↑                业绩→
 *   ┌──────────┬───────────┬──────────┐
 *   │   3      │ 2+ 核心骨干│ 1 超级明星│
 *   │ 业绩待提升│  (HM)     │  (HH)    │
 *   │ HL+ML    ├───────────┼──────────┤
 *   │ 合并     │ 2 中坚力量 │ 2+ 核心骨干│
 *   │          │  (MM)     │  (MH)    │
 *   ├──────────┼───────────┴──────────┤
 *   │   5      │            4         │
 *   │ 素质业绩  │       素质待提升      │
 *   │ 待提升    │       LM+LH 合并      │
 *   │  (LL)    │                      │
 *   └──────────┴──────────────────────┘
 *
 * cell key 始终用 `${quality}${perf}` 格式（quality 在前），与后端
 * `calculation.controller.ts` 输出的 `r.finalCell` 一致。
 */

export type Quality = 'H' | 'M' | 'L';
export type Perf = 'L' | 'M' | 'H';
export type Cell = `${Quality}${Perf}`;

export const ALL_CELLS: Cell[] = [
  'HH',
  'HM',
  'HL',
  'MH',
  'MM',
  'ML',
  'LH',
  'LM',
  'LL',
];

export interface BoxDef {
  id: string;
  rank: string;
  name: string;
  cells: Cell[];
  bg: string;
  ref: string;
  gridArea: string;
}

export const BOXES: BoxDef[] = [
  {
    id: 'box-improve-perf',
    rank: '3',
    name: '业绩待提升',
    cells: ['HL', 'ML'],
    bg: '#F5A86C',
    ref: '10%-15%',
    gridArea: '1 / 1 / 3 / 2',
  },
  {
    id: 'box-core-1',
    rank: '2+',
    name: '核心骨干',
    cells: ['HM'],
    bg: '#4A90E2',
    ref: '15%',
    gridArea: '1 / 2 / 2 / 3',
  },
  {
    id: 'box-star',
    rank: '1',
    name: '超级明星',
    cells: ['HH'],
    bg: '#62B362',
    ref: '5%-10%',
    gridArea: '1 / 3 / 2 / 4',
  },
  {
    id: 'box-mid',
    rank: '2',
    name: '中坚力量',
    cells: ['MM'],
    bg: '#5DB6DC',
    ref: '35%-50%',
    gridArea: '2 / 2 / 3 / 3',
  },
  {
    id: 'box-core-2',
    rank: '2+',
    name: '核心骨干',
    cells: ['MH'],
    bg: '#4A90E2',
    ref: '15%',
    gridArea: '2 / 3 / 3 / 4',
  },
  {
    id: 'box-improve-both',
    rank: '5',
    name: '素质业绩待提升',
    cells: ['LL'],
    bg: '#DD4A4A',
    ref: '5%',
    gridArea: '3 / 1 / 4 / 2',
  },
  {
    id: 'box-improve-quality',
    rank: '4',
    name: '素质待提升',
    cells: ['LM', 'LH'],
    bg: '#F5B942',
    ref: '10%',
    gridArea: '3 / 2 / 4 / 4',
  },
];
